// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css, keyframes } from 'styled-components';

import SpinePlayer from '../../../../components/SpinePlayer';
import Formatter from '../../../../i18n/formatter';
import { getCurrency } from '../../../../i18n/l10n';
import theme from '../../../../styled-components/dark';
import { SpineAnimationIds } from '../../../../types/animations';
import { SoundIds } from '../../../../types/sounds';
import { type KLRound, KLRounds } from '../../types/round';

const VictorySoundIds: { [roundId: KLRound]: Array<string> } = {
  [KLRounds.T_RED]: [
    SoundIds.KL_VICTORY_1,
    SoundIds.KL_VICTORY_2,
    SoundIds.KL_VICTORY_4,
    SoundIds.KL_VICTORY_10,
    SoundIds.KL_VICTORY_11,
  ],
  [KLRounds.T_WHITE]: [
    SoundIds.KL_VICTORY_1,
    SoundIds.KL_VICTORY_2,
    SoundIds.KL_VICTORY_4,
    SoundIds.KL_VICTORY_10,
    SoundIds.KL_VICTORY_11,
  ],
  [KLRounds.ORIENTATION]: [
    SoundIds.KL_VICTORY_1,
    SoundIds.KL_VICTORY_2,
    SoundIds.KL_VICTORY_4,
    SoundIds.KL_VICTORY_10,
    SoundIds.KL_VICTORY_11,
  ],
  [KLRounds.POLE]: [
    SoundIds.KL_VICTORY_3,
    SoundIds.KL_VICTORY_5,
    SoundIds.KL_VICTORY_6,
    SoundIds.KL_VICTORY_7,
    SoundIds.KL_VICTORY_8,
    SoundIds.KL_VICTORY_9,
  ],
};

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const sharedTextStyle = css`
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;

  opacity: 0;
  animation: ${fadeInAnimation} 1.5s ease 2.3s;
  animation-fill-mode: forwards;
`;

const Title = styled.div`
  font-size: 2em;
  margin-top: -0.8em;

  ${sharedTextStyle}
`;

const SpinePlayerWrapper = styled.div`
  width: 100%;
  padding-bottom: 90%;
`;

const StyledSpinePlayer = styled(SpinePlayer)`
  width: 100%;
  height: 100%;
  top: 0;
`;

const Text = styled.div`
  font-size: 1.5em;

  ${sharedTextStyle};
`;

const priceAnimation = keyframes`
  0% {
    opacity: 0;
    transform: scale(2);
  }
  90% {
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Price = styled.div`
  font-size: 2em;
  color: ${theme.KLNotification.highlightColor};
  padding-bottom: 1em;

  ${sharedTextStyle}

  animation: ${priceAnimation} 0.6s ease-in 2.8s;
  animation-fill-mode: forwards;
`;

const SmallText = styled.span`
  font-size: 0.7em;
  margin-top: -0.5em;
`;

type KLNotificationVictoryProps = {
  amount: number;
  round: KLRound;
};

const KLNotificationVictory = ({ amount, round }: KLNotificationVictoryProps) => {
  const currency = getCurrency();
  const displayedFreeBetValue = useMemo(() => Formatter.formatBankroll(amount, currency), [amount, currency]);
  const soundId = useMemo(() => {
    const rand = Math.floor(Math.random() * (VictorySoundIds[round]?.length ?? 0));
    return VictorySoundIds[round]?.find((_, i) => rand === i);
  }, [round]);

  return (
    <>
      <Title>Bravo !</Title>
      <SpinePlayerWrapper>
        <StyledSpinePlayer animationId={SpineAnimationIds.KL_VICTORY} soundId={soundId} scale={0.7} />
      </SpinePlayerWrapper>
      <Text>Vous gagnez</Text>
      <Price>
        {displayedFreeBetValue} <SmallText>en Freebets</SmallText>
      </Price>
    </>
  );
};

export default KLNotificationVictory;
